import { createVanIconComponent } from "./van"

const Replay = createVanIconComponent("replay")
export default Replay
